import { render, staticRenderFns } from "./FestivalSanBaFuNvJie.vue?vue&type=template&id=1bc703f4&scoped=true"
import script from "./FestivalSanBaFuNvJie.vue?vue&type=script&lang=js"
export * from "./FestivalSanBaFuNvJie.vue?vue&type=script&lang=js"
import style0 from "./FestivalSanBaFuNvJie.vue?vue&type=style&index=0&id=1bc703f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc703f4",
  null
  
)

export default component.exports